'use client';

import { segment } from '@hyphengroup/cms-components/modules/segment';
import { JsonObject } from 'utils/json';

export const pushDataLayer = (data: JsonObject): void => {
  if (typeof window !== 'undefined') {
    if (window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);

      // Send to Segment
      if (typeof data.event === 'string') {
        segment.track(data.event, data);
      }
    } else {
      console.log({ data });
    }
  }
};
